<div class="outer-content">
  <div *ngIf="displayPage" role="dialog" id="modal-dialog" aria-labelledby="dialog-label" aria-modal="true" class="wh-auto">
    <div class="float-left float-left bg-white card-background wh-auto">
      <form [formGroup]="lifestyleForm" autocomplete="off" role="form" class="fieldHeight">
        <div *ngIf="componentRefOfControlType">
          <app-content-top-nav [emitInvalidEvtFlag]="true" [cdRefParent]="componentRefOfControlType.instance.cdRef" [parentElement]="el" [parentFormToValidate]="componentRefOfControlType.instance.parentForm"
            [saverAndReturnObj]="saverAndReturnObj" [visibleBackNav]='true' (onBackClickHandler)="onBackClick()" [enableBackNav]='true'
            (onCloseClickHandler)="closePage()"></app-content-top-nav>
        </div>
        <div class="col-md-12 clear-all title-wrapper"
         [ngClass]="showAddAccordionBtn ? 'mar-bot-10':'mar-bot-unset'">
          <h1 class="title-text custom-header-h2 responsive-text-8" id="diabetesMC-header">{{selectedTitle}}</h1>
          <div class="col-md-6 accord-btn" *ngIf="showAddAccordionBtn">
            <button (click)="addAnotherAccordion()" [disabled]="disableAddAccordionBtnFlag" class="btn ml-30 btn-primary btn-border text-left min-width"
              type="button" id="addAccordionBtn">Add another heart condition
              <i aria-hidden="true" class="icon icon-plus fl-left"></i>
            </button>
          </div>
        </div>
        <div [ngClass]="dependantFlag ? 'col-md-12 clear-all dep-flex-container':'col-md-12 clear-all flex-container'" >
            <p role="heading" class="Help-us-understand-y" id="diabetesMC-subTitle" *ngIf="dependantFlag">
                <b>{{contentData.subTitle}}</b>
              </p>
          <p role="heading" aria-level="2" class="Help-us-understand-y" id="diabetesMC-introduction">
            {{contentData.introduction}}
          </p>
        </div>
        <div class="col-md-12 clear-all content-wrapper margin-top-0">
          <!-- <div class="row">
          </div> -->

          <div class="col-md-12 clear-all">
            <ng-template mandatory-questions-dir></ng-template>
          </div>

        </div>

        <div class="col-md-12 underline margin-top"></div>
        <div class="col-md-12 clear-all bottom-container">
          <div *ngIf="componentRefOfControlType">
            <div class="float-left" *ngIf="!isHOView">
              <app-save [emitInvalidEvtFlag]="true" [cdRefParent]="componentRefOfControlType.instance.cdRef" [parentElement]="el" [parentFormToValidate]="componentRefOfControlType.instance.parentForm"
                [saverAndReturnObj]="saverAndReturnObj" (closeSaveModal)="saveAndReturnToMedCondn()" [location]="'contentBottom'"></app-save>
            </div>
          </div>
          <div class="float-right">
            <app-content-bottom-nav (onNextHandler)="gotoNext()" [userInputDetail]="userInputDetail['buttonConfig']" [buttonType]="'normalCTA'"></app-content-bottom-nav>
          </div>
        </div>
        <app-modal *ngIf="displayAlert" [modalConfig]="alertDiabetesModalConfig" (closeModal)="closeModal()" (primaryBtnClick)="addMedicalCondtion()"
          (secondaryBtnClick)="navigateToMedicalCondition()" [saveDataFlag]="true"></app-modal>
      </form>
    </div>
  </div>
</div>